// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel from '../../model/get-organisation-by-external-id-and-event-identifier-async-request-model';
import GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO from '../dto/get-organisation-by-external-id-and-event-identifier-async-request-dto';
import dtoSchema from '../schemas/get-organisation-by-external-id-and-event-identifier-async-request-schema';

export default abstract class GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO>) {
    super();
    if (data) {
      this.externalId = data.externalId;
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  */
  externalId?: string;
  /**
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO>): GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel;
  static toModel(dto: DeepPartial<GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO> | undefined | null): GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel | undefined;
  static toModel(dto: DeepPartial<GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO> | undefined | null): GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel | undefined {
    return dto ? new GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel> | GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel): GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      externalId: unwrapped.externalId,
      eventIdentifier: unwrapped.eventIdentifier,
    } as GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel, can not map to GetOrganisationByExternalIdAndEventIdentifierAsyncRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
